import { BadgeVariant } from "shared/components";
import { ApplicationStatus, VerificationStatus } from "shared/types";

export const OCROLUS_FAIL_STATUSES = ["UNABLE_TO_PROCESS", "UNSUPPORTED"];

export const INCOME_STATUSES = {
  failed: "Rejected",
  verified_with_warnings: "Warning",
  verified: "Accepted",
  manually_verified: "Manually verified",
  in_progress: "In progress",
  completed_with_override: "Completed with override"
};

type IncomeSourceBadge = {
  variant: BadgeVariant;
  title: string;
  tooltip?: string;
};

export const INCOME_SOURCE_BADGE_STATUSES_MAP: {
  [key: string]: IncomeSourceBadge;
} = {
  Rejected: {
    variant: BadgeVariant.ERROR,
    title: "Rejected"
  },
  Warning: {
    variant: BadgeVariant.WARNING,
    title: "Verified with warnings"
  },
  Accepted: {
    variant: BadgeVariant.SUCCESS,
    title: "Verified"
  },
  NoTransactions: {
    variant: BadgeVariant.BASE,
    title: "No transactions selected"
  },
  Started: {
    variant: BadgeVariant.WARNING,
    title: "In progress"
  },
  Overridden: {
    variant: BadgeVariant.BASE,
    title: "Completed with override",
    tooltip: "Verification manually marked as complete"
  }
};

export const INCOMPLETE_VERIFICATION_STATUSES = [
  VerificationStatus.Pending,
  VerificationStatus.Started,
  VerificationStatus.Processing
];

export const COMPLETE_VERIFICATION_STATUSES = [
  VerificationStatus.Finished,
  VerificationStatus.FinishedWithWarnings,
  VerificationStatus.FinishedByOverridden
];

export const INCOMPLETE_APPLICATION_STATUSES = [
  ApplicationStatus.Pending,
  ApplicationStatus.Started,
  ApplicationStatus.PartiallySubmitted
];
